import { Injectable } from '@angular/core';
import { TableObject } from '../../../models/tableObject';
import { VwLabSotto100 } from '../../../models/vwLabSotto100';
import { HttpClient } from '@angular/common/http';
import { ConstantsStore } from '../constants.store';

@Injectable({
  providedIn: 'root'
})
export class Sotto100Service {

  constructor(
    private http: HttpClient,
    private urlsStore: ConstantsStore
  ) { }

  public get(
    pageNumber: number,
    pageSize: number,
    filter: string,
    ascending: boolean): Promise<TableObject<VwLabSotto100>> {

    return new Promise((resolve, reject) => {
      this.httpGet(pageNumber, pageSize, filter, ascending)
        .toPromise()
        .then(
          (res: TableObject<VwLabSotto100>) => resolve(res),
          (error: any) => reject(error)
        );
    });
  }

  public getForGuests(): Promise<TableObject<VwLabSotto100>> {
    return new Promise((resolve, reject) => {
      this.httpGetGuest()
        .toPromise()
        .then(
          (res: VwLabSotto100[]) => {
            const result: TableObject<VwLabSotto100> = {
              records: res,
              totalRecords: res.length
            };
            resolve(result);
          },
          (error: any) => reject(error)
        );
    });
  }


  httpGet(pageNumber: number, pageSize: number, filter: string, ascending: boolean) {
    const sotto100Url = `${this.urlsStore.sotto100Url}/${pageNumber}/${pageSize}${this.urlsStore.filterAndAscendingQueryString(filter, ascending)}`;
    return this.http.get<TableObject<VwLabSotto100>>(sotto100Url);
  }

  httpGetGuest() {
    return this.http.get<VwLabSotto100[]>(this.urlsStore.sotto100Url);
  }

  downloadExcel(pageSize: number) {
    const sotto100DownloadExcelUrl = `${this.urlsStore.sotto100Url}/download/${pageSize}`;
    return this.http.post(sotto100DownloadExcelUrl, null, {responseType: 'blob'}).toPromise();
  }

}
